export enum Routes {
  LOGIN = '',
  ADM = '/adm',
  HOME = '/home',
  MANAGER_INICIO = '/manager-inicio',
  MANAGER_LISTA_PRODUTOS = '/manager-lista',
  MANAGER_INFORMACOES_USUARIO = '/manager-user-info',
  MANAGER_PRESENTES_CONFIRMADOS = '/view-items',
  MANAGER_HISTORICO_ACESSOS = '/people-entered',
}